import React, { Component } from "react";
import { connect } from "react-redux";

import {
  IconButton,
  Menu,
  MenuItem,
} from "@mui/material";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

import { ScreenTitles } from "../ScreenTitles";

class ScreenDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
      open: false,
    }
  }

  scrollHorizontal = (screenIndex) => {
    window.scroll({
      top: 0, 
      left: screenIndex * 1920, 
      behavior: 'smooth' 
    });
  }
  scrollVertical = (screenIndex) => {
    window.scroll({
      top: screenIndex * 1080, 
      left: 0,
      behavior: 'smooth'
    });
  }

  handleClick = (event) => {
    this.setState({
      anchorEl: event.currentTarget,
      open: Boolean(event.currentTarget)
    });
  };
  handleClose = (event) => {
    this.setState({
      anchorEl: event.currentTarget,
      open: Boolean(null)
    });
  };
  handleSelect = (screenIndex) => {
    this.setState({
      anchorEl: null,
      open: Boolean(null),
    });
    this.props.orientationHorizontal ? this.scrollHorizontal(screenIndex) : this.scrollVertical(screenIndex);
  };
  
  render () {
    return (
      <div className="screen-dropdown">
        <IconButton
          aria-label="more"
          id="long-button"
          aria-expanded={this.state.open ? 'true' : undefined}
          aria-haspopup="true"
          onClick={this.handleClick}
          style={{
            color: "white",
          }}
        >
          <ArrowDropDownIcon fontSize="large" />
        </IconButton>
        <Menu
          id="long-menu"
          MenuListProps={{
            'aria-labelledby': 'long-button',
          }}
          anchorEl={this.state.anchorEl}
          open={this.state.open}
          onClose={this.handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          {ScreenTitles.map((option, i) => (
            <MenuItem
              key={option.title}
              onClick={()=>this.handleSelect(i)}
              style={{
                fontSize: "2em"
              }}
            >
              {option.title}
            </MenuItem>
          ))}
        </Menu>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    orientationHorizontal: state.ScreensCommonReducer.orientationHorizontal,
  };
}

export default connect(mapStateToProps)(ScreenDropdown);
